import { render, staticRenderFns } from "./BaseListOrdered.vue?vue&type=template&id=d58410b2&"
import script from "./BaseListOrdered.vue?vue&type=script&lang=js&"
export * from "./BaseListOrdered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports